import React, {useEffect, useState} from 'react';

function Input({endPointURI, requestID, serviceDeskURI, inputName, action,lastURI=""}) {

    const [url, setUrl] = useState(endPointURI ? endPointURI : '');
    useEffect(() => {

        if (inputName) {
            if (!action.fields[inputName]) {
                let newText = serviceDeskURI + "" + endPointURI + "" + requestID+""+lastURI;
                action.fields[inputName] = {value: newText};
            } else {
                setUrl(action.fields[inputName]?.value);
            }
        }
    }, [])

    useEffect(() => {
        if (!(action.fields[inputName]?.value)) {
            let newText = serviceDeskURI + "" + endPointURI + "" + requestID+""+lastURI;
            action.fields[inputName] = {value:newText};
            setUrl(endPointURI)

        } else {
            action.fields[inputName].value = (serviceDeskURI + "" + endPointURI + "" + requestID+""+lastURI);
            setUrl(serviceDeskURI + "" + endPointURI + "" + requestID+""+lastURI);
        }

    }, [serviceDeskURI, requestID, action])


    return (
        <div>
            <input className="editable" disabled value={url}/>
        </div>
    );
}

export default Input;